import { LoadingStatus } from '@general/js/enums';
import AbstractClass from './JoinNowAbstractServices';

import { AwaitResponse } from '../../utils/MockUtils';

export default class JoinNowServices extends AbstractClass {
  /**
   * Returns a mock list of predictive address from kleber API
   */
  static getPredictiveAddress(addressLine) {
    // only call api if addressLine is not empty string. if addressLine is empty, return null
    if (addressLine !== '') {
      logger.log(addressLine);
      return AwaitResponse({
        DtResponse: {
          $: {
            ErrorMessage: '',
            RequestId: '',
            ResultCount: '3',
          },
          Result: [
            {
              $: {
                AddressLine: '2 London Rd',
                Locality: 'ABERFOYLE PARK',
                Postcode: '5159',
                RecordId: 'AuPaf495384357',
                State: 'SA',
              },
            },
            {
              $: {
                AddressLine: '2 London St',
                Locality: 'ASHGROVE',
                Postcode: '4060',
                RecordId: 'AuPaf425393456',
                State: 'QLD',
              },
            },
            {
              $: {
                AddressLine: '2 London Link',
                Locality: 'AUBIN GROVE',
                Postcode: '6164',
                RecordId: 'AuPaf98800071X',
                State: 'WA',
              },
            },
          ],
        },
      });
    }

    return null;
  }

  /**
   * Returns a mock details of address from kleber API.
   */
  static getAddressDetails() {
    return AwaitResponse({
      DtResponse: {
        $: {
          ErrorMessage: '',
          RequestId: '',
          ResultCount: '1',
        },
        Result: [
          {
            $: {
              AddressLine: 'Unit 1 2-4 London St',
              BuildingName: '',
              DPID: '95799216',
              LevelNumber: '',
              LevelType: '',
              Locality: 'CAMPSIE',
              LotNumber: '',
              PostBoxNumber: '',
              PostBoxNumberPrefix: '',
              PostBoxNumberSuffix: '',
              PostBoxType: '',
              Postcode: '2194',
              State: 'NSW',
              StreetName: 'London',
              StreetNumber1: '2',
              StreetNumber2: '4',
              StreetNumberSuffix1: '',
              StreetNumberSuffix2: '',
              StreetSuffix: '',
              StreetType: 'St',
              UnitNumber: '1',
              UnitType: 'Unit',
            },
          },
        ],
      },
    });
  }

  /**
   * Returns mock details of the Join Now Reference Data API
   */
  static getReferenceData() {
    return AwaitResponse({
      compositionOptions: [
        {
          display: 'Single person',
          returnValue: 'single',
        },
        {
          display: 'Couple',
          returnValue: 'couple',
        },
        {
          display: 'Family',
          returnValue: 'family',
        },
        {
          display: 'Single parent family',
          returnValue: 'singleParent',
        },
        {
          display: 'Child / Children only',
          returnValue: 'childrenOnly',
        },
      ],
      sex: {
        label: null,
        helpText: 'We collect biological sex to support claims processes',
        options: [
          {
            display: 'Male',
            returnValue: 'M',
          },
          {
            display: 'Female',
            returnValue: 'F',
          },
        ],
      },
      phoneTypeOptions: [
        {
          display: 'Mobile',
          returnValue: 'Mobile',
        },
        {
          display: 'Work',
          returnValue: 'Work',
        },
        {
          display: 'Home',
          returnValue: 'Home',
        },
      ],
      stateOptions: [
        {
          display: 'ACT',
          returnValue: 'ACT',
        },
        {
          display: 'NSW',
          returnValue: 'NSW',
        },
        {
          display: 'NT',
          returnValue: 'NT',
        },
        {
          display: 'QLD',
          returnValue: 'QLD',
        },
        {
          display: 'SA',
          returnValue: 'SA',
        },
        {
          display: 'TAS',
          returnValue: 'TAS',
        },
        {
          display: 'VIC',
          returnValue: 'VIC',
        },
        {
          display: 'WA',
          returnValue: 'WA',
        },
      ],
      communicationMethodOptions: [
        {
          display: 'Email',
          returnValue: 'Email',
        },
        {
          display: 'Post',
          returnValue: 'Post',
        },
      ],
      insuranceFundOptions: [
        {
          display: 'ACA Health Benefits Fund',
          returnValue: 'ACA',
        },
        {
          display: 'AHM',
          returnValue: 'AHM',
        },
        {
          display: 'AIA',
          returnValue: 'AIA',
        },
        {
          display: 'APIA',
          returnValue: 'Unk9',
        },
        {
          display: 'Australian Unity Health Ltd',
          returnValue: 'AU',
        },
        {
          display: 'Budget Direct Health Insurance',
          returnValue: 'Unk6',
        },
        {
          display: 'BUPA Health Insurance',
          returnValue: 'BUP',
        },
        {
          display: 'CBHS Corporate Health Pty Ltd',
          returnValue: 'CBC',
        },
        {
          display: 'CBHS Health Fund Ltd',
          returnValue: 'CBHS',
        },
        {
          display: 'CDH Benefits Fund',
          returnValue: 'CDH',
        },
        {
          display: 'Central West Health Fund',
          returnValue: 'Unk4',
        },
        {
          display: 'CUA Health Fund',
          returnValue: 'CUA',
        },
        {
          display: 'Defence Health Ltd',
          returnValue: 'AHBS',
        },
        {
          display: 'Doctors Health Fund',
          returnValue: 'AMA',
        },
        {
          display: 'Emergency Services Health',
          returnValue: 'ESH',
        },
        {
          display: 'Fit Health Insurance',
          returnValue: 'Unk2',
        },
        {
          display: 'Frank Health Insurance',
          returnValue: 'Unk1',
        },
        {
          display: 'GMF Health Fund',
          returnValue: 'GMF',
        },
        {
          display: 'GMHBA Health Fund',
          returnValue: 'GMHBA',
        },
        {
          display: 'GU Health Fund',
          returnValue: 'GUC',
        },
        {
          display: 'HBF',
          returnValue: 'HBF',
        },
        {
          display: 'HCF',
          returnValue: 'HCF',
        },
        {
          display: 'Health Care Insurance Ltd.',
          returnValue: 'HCI',
        },
        {
          display: 'Health Partners',
          returnValue: 'HP',
        },
        {
          display: 'Health.com',
          returnValue: 'Unk5',
        },
        {
          display: 'HIF',
          returnValue: 'HIF',
        },
        {
          display: 'Latrobe Health Services Inc',
          returnValue: 'LHS',
        },
        {
          display: 'Medibank Private',
          returnValue: 'MP',
        },
        {
          display: 'Mildura District Hospital Fund',
          returnValue: 'MDH',
        },
        {
          display: 'Navy Health',
          returnValue: 'NAVY',
        },
        {
          display: 'NIB Health Funds Limited',
          returnValue: 'NIB',
        },
        {
          display: 'Nurses & Midwives Health',
          returnValue: 'NMW',
        },
        {
          display: 'ONE MEDI FUND',
          returnValue: 'OMF',
        },
        {
          display: 'Peoplecare',
          returnValue: 'LHMC',
        },
        {
          display: 'Phoenix Health Fund',
          returnValue: 'PWAL',
        },
        {
          display: 'Police Health',
          returnValue: 'SAPOL',
        },
        {
          display: 'Qantas',
          returnValue: 'Unk8',
        },
        {
          display: 'Queensland Country Health Limited',
          returnValue: 'QCH',
        },
        {
          display: 'Queensland teachers union',
          returnValue: 'QTUHS',
        },
        {
          display: 'R&T Health Fund',
          returnValue: 'RTEFS',
        },
        {
          display: 'RACQ Health Insurance',
          returnValue: 'Unk7',
        },
        {
          display: 'Reserve Bank Health Society',
          returnValue: 'RBHS',
        },
        {
          display: "St Luke's Health",
          returnValue: 'SLMHB',
        },
        {
          display: 'Teachers Health',
          returnValue: 'NSWTF',
        },
        {
          display: 'Transport Health',
          returnValue: 'TFS',
        },
        {
          display: 'UniHealth Insurance',
          returnValue: 'UHI',
        },
        {
          display: 'Westfund',
          returnValue: 'WDHF',
        },
      ],
      insuranceFundInformationText: {
        informationText: 'By providing the details of your previous fund you authorise Defence Health to request cancellation of the products held with your previous health fund.',
      },
      veteranCardConditionOptions: [
        {
          display: 'Alcohol Dependence & Abuse',
          returnValue: 'DVAC2',
        },
        {
          display: 'Ankle',
          returnValue: 'DVAC1',
        },
        {
          display: 'Arm/Hand',
          returnValue: 'DVACD',
        },
        {
          display: 'Back',
          returnValue: 'DVAC7',
        },
        {
          display: 'Cancer (Malignant Neoplasm)',
          returnValue: 'DVAC4',
        },
        {
          display: 'Cardiac',
          returnValue: 'DVAC5',
        },
        {
          display: 'Hearing Loss/Tinnitus',
          returnValue: 'DVAC6',
        },
        {
          display: 'Hip',
          returnValue: 'DVACB',
        },
        {
          display: 'Knee',
          returnValue: 'DVACA',
        },
        {
          display: 'Mental Health Conditions',
          returnValue: 'DVAC3',
        },
        {
          display: 'Neck',
          returnValue: 'DVACC',
        },
        {
          display: 'Osteoarthritis',
          returnValue: 'DVAC8',
        },
        {
          display: 'Other',
          returnValue: 'DVACO',
        },
        {
          display: 'PTS Disorder',
          returnValue: 'DVAC9',
        },
        {
          display: 'Shoulder',
          returnValue: 'DVAC0',
        },
        {
          display: 'Pulmonary Tuberculosis',
          returnValue: 'DVACE',
        },
      ],
      veteranCardGoldTypeInformationText: {
        informationText: 'Private Health Insurance is not generally required in addition to a DVA Gold Card. ',
      },
      veteranCardTypeOptions: [
        {
          display: 'Veteran Gold Card',
          returnValue: 'Veteran Gold Card',
        },
        {
          display: 'Veteran White Card',
          returnValue: 'Veteran White Card',
        },
      ],
      veteranCardConditionInformationText: {
        informationText:
          '<p>By providing your&nbsp;Veteran Card details,&nbsp;you agree to claim&nbsp;eligible benefit&nbsp;entitlements through&nbsp;DVA first.</p>\r\n\r\n<p>Using the search below, select all&nbsp;the conditions that are listed as&nbsp;covered by your Veteran White&nbsp;Card. Or upload supporting&nbsp;documents that list the conditions covered by your card.</p>\r\n',
      },
      concessionCardInformationText: {
        informationText:
          'Advising us whether you hold a concession card ensures we are not paying for services that you are already entitled to, which helps us keep premiums more affordable.',
      },
      concessionCardOptions: [
        {
          display: 'Commonwealth Seniors Health Card',
          returnValue: 'CSHC',
        },
        {
          display: 'Health Care Card',
          returnValue: 'HCC',
        },
        {
          display: 'Pensioner Concession Card',
          returnValue: 'PCC',
        },
        {
          display: 'Veterans Service Pension Card',
          returnValue: 'VSPC',
        },
      ],
      serviceConnectionOptions: [
        {
          display: 'Self',
          returnValue: 'Self',
        },
        {
          display: 'Partner',
          returnValue: 'Partner',
        },
      ],
      serviceAgencyOptions: [
        {
          display: 'Navy',
          returnValue: 'Navy',
        },
        {
          display: 'Airforce',
          returnValue: 'Airforce',
        },
        {
          display: 'Army',
          returnValue: 'Army',
        },
      ],
      serviceConnectionRelationshipOptions: [
        {
          display: 'Child',
          returnValue: 'Child',
        },
        {
          display: 'Parent',
          returnValue: 'Parent',
        },
        {
          display: 'Grandparent',
          returnValue: 'Grandparent',
        },
        {
          display: 'Brother or Sister',
          returnValue: 'Brother or Sister',
        },
        {
          display: 'Former Partner',
          returnValue: 'Former Partner',
        },
      ],
      sercat: {
        label: 'SERCAT status - 3, 4, 5, 6 or 7',
        helpText: '',
        options: [
          {
            display: 'SERCAT 3',
            returnValue: '3',
          },
          {
            display: 'SERCAT 4',
            returnValue: '4',
          },
          {
            display: 'SERCAT 5',
            returnValue: '5',
          },
          {
            display: 'SERCAT 6',
            returnValue: '6',
          },
          {
            display: 'SERCAT 7',
            returnValue: '7',
          },
        ],
      },
      eligibilityWorkedForOptions: [
        {
          display: 'Contractor',
          returnValue: 'Contractor',
        },
        {
          display: 'Defence Public Service',
          returnValue: 'Work for department',
        },
      ],
      eligibilityOptions: [
        {
          display: 'Currently serving',
          returnValue: 'Currently serving',
        },
        {
          display: 'Ex-serving',
          returnValue: 'Ex-serving',
        },
        {
          display: 'Contractor',
          returnValue: 'Contractor',
        },
        {
          display: 'Defence Public Service',
          returnValue: 'Defence Public Service',
        },
      ],
      rebateInformationText: {
        informationText:
          'The Australian Government Rebate on private health insurance may reduce the amount you pay for private health insurance. A rebate may still be claimed as a tax offset when you lodge your tax return. You can add a rebate in the Member Portal at anytime.',
      },
      rebateCoveredPolicyInformationText: {
        informationText:
          'Applicants not covered by the policy cannot claim the Australian Government Rebate on Private Health Insurance (excluding child only policies) and employers and trustees of organisations cannot claim the Australian Government Rebate on Private Health Insurance on policies paid on behalf of employees.',
      },
      rebateMedicareEligibleInformationText: {
        informationText: 'All the people listed on the policy must be eligible to claim Medicare for you to receive the rebate as a reduced premium.',
      },
      medicareCardTypeOptions: [
        {
          display: 'Green',
          returnValue: 'Green',
        },
        {
          display: 'Blue (Interim)',
          returnValue: 'Blue (Interim)',
        },
        {
          display: 'Yellow (Reciprocal)',
          returnValue: 'Yellow (Reciprocal)',
        },
      ],
      incomeTierSingleOptions: [
        {
          display: '$93,000 or less',
          returnValue: 'BASE_TIER',
        },
        {
          display: '$93,001 - $108,000',
          returnValue: 'TIER_1',
        },
        {
          display: '$108,001 - $144,000',
          returnValue: 'TIER_2',
        },
        {
          display: '$144,001 or more',
          returnValue: 'TIER_3',
        },
        {
          display: "Don't apply a rebate",
          returnValue: 'none',
        },
      ],
      incomeTierFamilyOptions: [
        {
          display: '$186,000 or less',
          returnValue: 'BASE_TIER',
        },
        {
          display: '$186,001 - $216,000',
          returnValue: 'TIER_1',
        },
        {
          display: '$216,001 - $288,000',
          returnValue: 'TIER_2',
        },
        {
          display: '$288,001 or more',
          returnValue: 'TIER_3',
        },
        {
          display: "Don't apply a rebate",
          returnValue: 'none',
        },
      ],
      incomeTierInformationText: {
        informationText:
          'Privacy and your personal information The privacy and security of your personal information is important to us, and is protected by law. We need to collect this information so we can process and manage your applications and payments, and provide services to you. We only share your information with other parties where you have agreed, or Page 11 of 13 where law allows or requires it. For more information, go to&nbsp;<a href="https://www.servicesaustralia.gov.au/individuals/privacy" target="_blank">servicesaustralia.gov.au/individuals/privacy</a>',
      },
      paymentPayingPremiumInformationText: {
        informationText:
          '<p>Direct debit from your bank account can occur every fortnight, month, quarter, half year or year. Credit card payments are made on the 15th of each month, quarter, half year or year.</p>\r\n\r\n<p>I/We request and authorise Defence Health (ID 3478) to debit funds from my/our nominated account according to the details specified below through the Bulk Electronic Clearing System (BECS).</p>\r\n',
      },
      paymentMethodOptions: [
        {
          display: 'Bank account',
          returnValue: 'B',
        },
        {
          display: 'Credit card',
          returnValue: 'C',
        },
      ],
      paymentFrequencyOptions: [
        {
          display: 'Fortnightly',
          returnValue: 'Fortnightly',
        },
        {
          display: 'Monthly',
          returnValue: 'Monthly',
        },
        {
          display: 'Quarterly',
          returnValue: 'Quarterly',
        },
        {
          display: 'Semi-annual',
          returnValue: 'Semi-annual',
        },
        {
          display: 'Annual',
          returnValue: 'Annual',
        },
      ],
      paymentUnderstandDebitAgreementInformationText: {
        informationText:
          'I have read and understood the <a href="https://stdhlwebsitdata001.blob.core.windows.net/pdfdocuments/additional/Direct%20debit%20service%20agreement.pdf" target="_blank">Direct Debit service agreement</a>. I understand the first deduction after joining or changing cover may include the premium for the nominated payment frequency plus a pro-rata amount. If a deduction falls on a non-business day, it will be debited from my account on the next business day. I authorise Defence Health to alter the amount of the deduction, if the premium for my policy changes. I understand that it is a condition of my membership that premiums are paid in advance. Any changes to my direct debit must be requested at least 2 days prior to the next deduction.',
      },
      paymentCardProcessingFeeInformationText: {
        informationText: '',
      },
      paymentBankClaimsSameAccountInformationText: {
        informationText: 'When you submit a claim with us, we will deposit any benefits into your nominated bank account.',
      },
      paymentBankClaimsInformationText: {
        informationText:
          'Defence Health can automatically deposit claim payments directly into your nominated bank, building society or credit union account. By completing this section you will be nominating an account for direct claims payment.',
      },
      paymentBankClaimsAuthorizationInformationText: {
        informationText:
          'I authorise Defence Health to pay this membership&rsquo;s claims benefits directly into my nominated account. I acknowledge that the claims payments for this membership will continue to be paid to my nominated account until I register a new account.',
      },
      privacyPolicyInformationText: {
        informationText:
          'I declare and acknowledge that:<br />\r\n<br />\r\nI have read and understood the <a href="/other/legal?open=one" target="_blank">Privacy Policy</a><br />\r\n<br />\r\nI have obtained the necessary consents from dependants over 16 years of age to disclose their personal information in this application form to Defence Health and give the same consents and authorisation I give in these declarations.<br />\r\n<br />\r\nI will make, or authorise the making of claims under this policy<br />\r\n<br />\r\nIf applicable I authorise my previous health funds to release to Defence Health all personal information concerning my dependants and me, which is required to confirm policy entitlements<br />\r\n<br />\r\nI am aware that Defence Health hospital products are not suitable for non- residents without Medicare entitlements (including overseas visitors from countries with Australian Government reciprocal health care arrangements).<br />\r\n<br />\r\nI have read and understood the product information contained in this website including limitation of benefits for pre-existing condition and waiting periods.',
      },
      serviceTypeOptions: [
        {
          display: 'Permanent',
          returnValue: 'Permanent',
        },
        {
          display: 'Reservist',
          returnValue: 'Reservist',
        },
      ],
      currentlyReceivingABDHelpText: {
        informationText:
          '<p>If you are aged 18-25, you could save 10%&nbsp;on your premium every year that you remain on eligible cover with the age-based discount.</p>\r\n\r\n<p>The discount reduces by 2% annually if you take out eligible hospital cover for 26 to 29 year olds, and phases out by 2% each year after you turn 41.</p>\r\n',
      },
      firstReceiveAgeBasedDiscountOptions: {
        minimum: 18,
        maximum: 29,
        other: "I don't know",
      },
      currentlyReceivingABDWithAgeHelpText: {
        informationText: 'Your certified discount age may be updated when we receive the transfer certificate from your previous health fund.',
      },
      currentlyReceivingABDWithoutAgeHelpText: {
        informationText: 'We will apply a discount&nbsp; based on your age today. This may be updated when we receive the transfer certificate from your previous health fund.',
      },
      healthInsuranceFirstTimeHelpText: {
        informationText:
          '<p>Your certified discount age is the age you are when you take out private hospital insurance for the first time.</p>\r\n\r\n<p>We use this to apply an&nbsp;<a href="/error" target="_blank">age-based discount</a>&nbsp;on your premium.</p>\r\n',
      },
      currentlyReceivingABDNoHelpText: {
        informationText:
          '<p>Your certified discount age is the age you are when you take out private hospital insurance for the first time or after you&rsquo;ve had a break in cover.</p>\r\n\r\n<p>We use this to apply&nbsp;<a href="/error" target="_blank">an age-based-discount</a>&nbsp;on your premium.</p>\r\n\r\n<p>This certified discount age may be updated when we receive the transfer certificate from your previous health fund.</p>\r\n',
      },
      lhcOptions: [
        {
          display: 'An Australian citizen or permanent resident recently returned from overseas',
          returnValue: 'OSE',
        },
        {
          display: 'A new migrant to Australia',
          returnValue: 'IMM',
        },
        {
          display: 'An ex-serving ADF member',
          returnValue: 'ADF',
        },
        {
          display: 'I have held hospital insurance continuously for last 10 years or since turning 31 years old',
          returnValue: 'YEA',
        },
        {
          display: 'None of the above',
          returnValue: 'NONE',
        },
      ],
      lhcMigrantHelpText: {
        informationText: '<p>We use this to assess any Lifetime Health Cover loading that needs to be applied to the premium.</p>\r\n',
      },
    });
  }

  /**
   * Returns mock quote details
   */
  static getQuoteDetails() {
    return AwaitResponse({
      quote: {
        quoteId: '38ce84d9-1cc4-eb11-bacc-00224818343d',
        name: 'Ultimate Hospital Gold & Essential Extras',
        expired: false,
        ranking: null,
        excess: 500.0,
        excessList: '0:250:500',
        quoteDate: '2021-06-23T00:00:00',
        products: [
          {
            name: 'Ultimate Hospital Gold',
            description: 'Designed to give you complete peace of mind. nComprehensive cover for peace of mind.nn',
            code: 'J19',
            type: 'Hospital',
            features: [
              {
                name: 'Assisted reproductive services',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for fertility treatments or procedures.',
                waitingPeriod: '',
              },
              {
                name: 'Back, neck and spine',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of the back, neck and spinal column, including spinal fusion.',
                waitingPeriod: '',
              },
              {
                name: 'Blood',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of blood and blood-related conditions.',
                waitingPeriod: '',
              },
              {
                name: 'Bone, joint and muscle',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of diseases, disorders and injuries of the musculoskeletal system.',
                waitingPeriod: '',
              },
              {
                name: 'Brain and nervous system',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of the brain, brain-related conditions, spinal cord and peripheral nervous system.',
                waitingPeriod: '',
              },
              {
                name: 'Breast surgery (medically necessary)',
                value: 'Included',
                featureType: 'hospital',
                description:
                  'Hospital treatment for the investigation and treatment of breast disorders and associated lymph nodes, and reconstruction and/or reduction following breast surgery or a preventative mastectomy. This clinical category does not require benefits to be paid for cosmetic breast surgery that is not medically necessary.',
                waitingPeriod: '',
              },
              {
                name: 'Cataracts',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for surgery to remove a cataract and replace with an artificial lens.',
                waitingPeriod: '',
              },
              {
                name: 'Chemotherapy, radiotherapy and immunotherapy for cancer',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for chemotherapy, radiotherapy and immunotherapy for the treatment of cancer or benign tumours.',
                waitingPeriod: '',
              },
              {
                name: 'Dental surgery',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for surgery to the teeth and gums.',
                waitingPeriod: '',
              },
              {
                name: 'Diabetes management (excluding insulin pumps)',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and management of diabetes.',
                waitingPeriod: '',
              },
              {
                name: 'Dialysis for chronic kidney failure',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for dialysis treatment for chronic kidney failure.',
                waitingPeriod: '',
              },
              {
                name: 'Digestive system',
                value: 'Included',
                featureType: 'hospital',
                description:
                  'Hospital treatment for the investigation and treatment of the digestive system, including the oesophagus, stomach, gall bladder, pancreas, spleen, liver and bowel.',
                waitingPeriod: '',
              },
              {
                name: 'Ear, nose and throat',
                value: 'Included',
                featureType: 'hospital',
                description:
                  'Hospital treatment for the investigation and treatment of the ear, nose, throat, middle ear, thyroid, parathyroid, larynx, lymph nodes and related areas of the head and neck.',
                waitingPeriod: '',
              },
              {
                name: 'Eye (not cataracts)',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of the eye and the contents of the eye socket.',
                waitingPeriod: '',
              },
              {
                name: 'Gastrointestinal endoscopy',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the diagnosis, investigation and treatment of the internal parts of the gastrointestinal system using an endoscope.',
                waitingPeriod: '',
              },
              {
                name: 'Gynaecology',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of the female reproductive system.',
                waitingPeriod: '',
              },
              {
                name: 'Heart and vascular system',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of the heart, heart-related conditions and vascular system.',
                waitingPeriod: '',
              },
              {
                name: 'Hernia and appendix',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of a hernia or appendicitis.',
                waitingPeriod: '',
              },
              {
                name: 'Hospital psychiatric services',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the treatment and care of patients with psychiatric, mental, addiction or behavioural disorders.',
                waitingPeriod: '',
              },
              {
                name: 'Implantation of hearing devices',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment to correct hearing loss, including implantation of a prosthetic hearing device.',
                waitingPeriod: '',
              },
              {
                name: 'Insulin pumps',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the provision and replacement of insulin pumps for treatment of diabetes.',
                waitingPeriod: '',
              },
              {
                name: 'Joint reconstructions',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for surgery for joint reconstructions.',
                waitingPeriod: '',
              },
              {
                name: 'Joint replacements',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for surgery for joint replacements, including revisions, resurfacing, partial replacements and removal of prostheses.',
                waitingPeriod: '',
              },
              {
                name: 'Kidney and bladder',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of the kidney, adrenal gland and bladder.',
                waitingPeriod: '',
              },
              {
                name: 'Lung and chest',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of the lungs, lung-related conditions, mediastinum and chest.',
                waitingPeriod: '',
              },
              {
                name: 'Male reproductive system',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of the male reproductive system including the prostate.',
                waitingPeriod: '',
              },
              {
                name: 'Miscarriage and termination of pregnancy',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of a miscarriage or for termination of pregnancy.',
                waitingPeriod: '',
              },
              {
                name: 'Pain management',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for pain management that does not require the insertion or surgical management of a device.',
                waitingPeriod: '',
              },
              {
                name: 'Pain management with device',
                value: 'Included',
                featureType: 'hospital',
                description:
                  'Hospital treatment for the implantation, replacement or other surgical management of a device required for the treatment of pain. For example: treatment of nerve pain, back pain, and pain caused by coronary heart disease with a device (for example an infusion pump or neurostimulator). Treatment of pain that does not require a device is listed separately under Pain management.',
                waitingPeriod: '',
              },
              {
                name: 'Palliative care',
                value: 'Included',
                featureType: 'hospital',
                description:
                  'Hospital treatment for care where the intent is primarily providing quality of life for a patient with a terminal illness, including treatment to alleviate and manage pain.',
                waitingPeriod: '',
              },
              {
                name: 'Plastic and reconstructive surgery (medically necessary)',
                value: 'Included',
                featureType: 'hospital',
                description:
                  'Hospital treatment which is medically necessary for the investigation and treatment of any physical deformity, whether acquired as a result of illness or accident, or congenital.',
                waitingPeriod: '',
              },
              {
                name: 'Podiatric surgery (by a registered podiatric surgeon)',
                value: 'Included',
                featureType: 'hospital',
                description:
                  'Hospital treatment for the investigation and treatment of conditions affecting the foot and/or ankle, provided by a registered podiatric surgeon but limited to cover for:· accommodation; and· the cost of a prosthesis as listed in the prostheses list set out in the Private Health Insurance (Prostheses) Rules, as in force from time to time.',
                waitingPeriod: '',
              },
              {
                name: 'Pregnancy and birth',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for investigation and treatment of conditions associated with pregnancy and child birth.',
                waitingPeriod: '',
              },
              {
                name: 'Rehabilitation',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for physical rehabilitation for a patient related to surgery or illness.',
                waitingPeriod: '',
              },
              {
                name: 'Skin',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation and treatment of skin, skin-related conditions and nails. The removal of foreign bodies is also included.',
                waitingPeriod: '',
              },
              {
                name: 'Sleep studies',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment for the investigation of sleep patterns and anomalies.',
                waitingPeriod: '',
              },
              {
                name: 'Tonsils, adenoids and grommets',
                value: 'Included',
                featureType: 'hospital',
                description: 'Hospital treatment of the tonsils, adenoids and insertion or removal of grommets.',
                waitingPeriod: '',
              },
              {
                name: 'Weight loss surgery',
                value: 'Included',
                featureType: 'hospital',
                description:
                  'Hospital treatment for surgery that is designed to reduce a person’s weight, remove excess skin due to weight loss and reversal of a bariatric procedure.',
                waitingPeriod: '',
              },
            ],
            excessList: '0:250:500',
            guideUrl: 'https://stdhlwebdevdata001.blob.core.windows.net/guides/adftotalpackagegold.pdf',
            waitingPeriod: null,
          },
          {
            name: 'Essential Extras',
            description: 'Low cost cover for the most popular extras.nValue for money cover on our most popular extras.nn',
            code: 'I5',
            type: 'Extras',
            features: [
              {
                name: 'Ambulance treatment',
                value: '$ Unlimited',
                featureType: 'extras',
                description:
                  "Comprehensive cover for ambulance services by state-appointed ambulance providers across Australia. No limits apply, so there's no need for a separate subscription. Cover includes: emergency services, non-emergency dispatch, mobile intensive care, air and sea ambulance services. Transport services by Patient Transport vehicles are not ambulance services and are not claimable",
                waitingPeriod: '2 months',
              },
              {
                name: 'General and preventive dental',
                value: '$500 per person',
                featureType: 'extras',
                description:
                  'Includes examinations, scale & clean, fluoride treatments, x-rays, simple extractions, most fillings, mouth-guards and other simple, dental treatments. *Some dental items are limited in the number of times they can be claimed in a year or appointment. Some are not payable in combination with others. And some may not attract a benefit at all.',
                waitingPeriod: '2 months',
              },
              {
                name: 'Health and wellbeing',
                value: '$200 per person',
                featureType: 'extras',
                description:
                  'Where the provider is recognised by the Australian Regional Health Group the following alternative therapies are payable: acupuncture, myotherapy and remedial massage. No benefit payable for any prescribed medications, herbal or dietary preparations. Included in this category is physiotherapy group therapy sessions and classes and excerise physiology group therapy. Benefits are available for approved health screening tests and programs.',
                waitingPeriod: '2 months',
              },
              {
                name: 'Laser refractive eye surgery',
                value: 'Excluded',
                featureType: 'extras',
                description: 'Payable for LASIK, PRK or smile eye surgery in recognised day surgery centre every 2 financial years.',
                waitingPeriod: '',
              },
              {
                name: 'Major dental',
                value: 'Excluded',
                featureType: 'extras',
                description: 'Complex dental services such as root canal therapy, surgical extractions, gum disease, dentures, implants, crowns and bridges.',
                waitingPeriod: '',
              },
              {
                name: 'Medically prescribed devices and appliances',
                value: 'Excluded',
                featureType: 'extras',
                description:
                  'A wide range of aids and appliances that help treat or supporta medial condition. Common examples include hearing aids, PAP machines, blood glucose monitors, mobility aids, compression garments, foot orthotics and nebulisers.',
                waitingPeriod: '',
              },
              {
                name: 'Optical',
                value: '$170 per person',
                featureType: 'extras',
                description: 'Provision of presciption glasses and contact lenses.',
                waitingPeriod: '2 months',
              },
              {
                name: 'Orthodontics',
                value: 'Excluded',
                featureType: 'extras',
                description: 'Dental services to address and realign bites',
                waitingPeriod: '',
              },
              {
                name: 'School accidents',
                value: 'Excluded',
                featureType: 'extras',
                description:
                  'Additional benefits for costs resulting from a school accident to your child. To cover the gaps after your extras benefits have been provided, excludes Medicare services.',
                waitingPeriod: '',
              },
              {
                name: 'Surgical tooth removal',
                value: '$500 per person',
                featureType: 'extras',
                description: '',
                waitingPeriod: '12 months',
              },
            ],
            excessList: '',
            guideUrl: 'https://stdhlwebdevdata001.blob.core.windows.net/guides/adftotalpackagegold.pdf',
            waitingPeriod: null,
          },
        ],
        flexi: {
          flexiLimit: '$450 per person',
          waitingPeriod: '2 months',
          description: 'The flexi-limit can be claimed across the range of included treatments, or you can choose to use it all on your favourite included treatment.',
          flexiFeatures: [
            {
              name: 'Antenatal and postnatal services',
              description:
                'Antenatal services are provided before having a baby and postnatal services are provided after having a baby. Benefits are payable for consultations and classes with a midwife or physiotherapist in private practice. Treatment claims through Medicare cannot be covered.',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Audiology',
              description: '',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Chiropractic/Osteopathic',
              description: '',
              waitingPeriod: '',
              value: 'Included',
            },
            {
              name: 'Dietitian',
              description: '',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Exercise physiology',
              description: '',
              waitingPeriod: '',
              value: 'Included',
            },
            {
              name: 'Eye therapy',
              description: '',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Occupational therapy',
              description: '',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Pharmacy and vaccinations',
              description: 'The benefit is payable on non-PBS pharmaceuticals only and applies to the cost in excess of the current PBS amount.',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Physiotherapy',
              description: '',
              waitingPeriod: '',
              value: 'Included',
            },
            {
              name: 'Podiatry/Chiropody',
              description: '',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Psychology',
              description: 'Treatment claimed through Medicare cannot be covered.',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Speech therapy',
              description: '',
              waitingPeriod: '',
              value: 'Excluded',
            },
            {
              name: 'Travel vaccinations',
              description: '',
              waitingPeriod: '',
              value: 'Included',
            },
          ],
        },
        calculationResultSetTotalResult: 241.05,
        paymentFrequency: 'Fortnightly',
      },
      opportunity: {
        opportunityId: '27c587d3-1cc4-eb11-bacc-00224818343d',
        secondAdultDateofBirth: '1978-03-11',
        composition: 'single',
        numberOfDependants: 0,
        coverType: 'Hospital & Extras',
        need: 'Specific Treatment',
        pregnancy: false,
        rebateTier: 'TIER_1',
        rebateTierIncomeDisplay: '$186,001 - $216,000',
        hadHospitalInsurance: true,
        dvaCard: true,
        eligibility: 'ADF',
        eligibilityDisplay: 'I/My partner is currently serving',
        contact: {
          contactId: '1bc587d3-1cc4-eb11-bacc-00224818343d',
          firstName: 'Elain',
          lastName: '',
          email: null,
          phone: null,
          dateOfBirth: '1950-12-01',
          primaryPhone: null,
          addressState: 'NSW',
        },
        hospitalNeeds: ['Assisted reproductive services'],
        extrasNeeds: ['Antenatal and postnatal services'],
        memberStatus: 'SWITCHING',
        myCircumstances: null,
      },
    });
  }

  static uploadDocument(files, GUID, fileType) {
    if (files && GUID && fileType === 'sercat') {
      return AwaitResponse('success');
    }
    throw new Error('mocking error');
  }

  static getProductPrice() {
    return AwaitResponse({
      productPrices: [
        {
          calculationResultSetTotalResult: 56.15,
          enrollmentProductCode: ['J18'],
        },
      ],
    });
  }

  /**
   * @deprecated Since Bambora has been replaced by Ipsi.
   */
  static convertSecureTransactionToken() {
    return AwaitResponse({
      creditCardToken: '9041935180334970',
      cardType: 'Visa',
      truncatedCard: '402400******9509',
      expiryMonth: '01',
      expiryYear: '2025',
      declinedMessage: null,
    });
  }

  // Get membership creation status
  static createMembership() {
    return AwaitResponse({
      memberNumber: '10020452',
      startDate: '2021-07-21T03:16:03.242Z',
      creationStatus: 'approved',
    });
  }

  // Mock upload file API for SERCAT - Change Cover CAI Eligibility Step
  static async uploadFile() {
    return AwaitResponse(LoadingStatus.SUCCESS);
  }
}
